import React from "react";

import ImportValues2 from "./ImportValues";
import moment from "moment";

const Portfolio = (props) => {
  const { portfolioEntry } = props;

  return (
    <div style={{ fontSize: 16, width: "fit-content", margin: 10 }}>
      <div>
        <div style={{ color: "#797878" }}>
          <p style={{ fontWeight: "bold", fontSize: 18 }}>
            Data Entry and Portfolio Privacy
          </p>
          <p>
            You may enter your data on-screen or you may import your portfolio
            data from Excel®, using our down-loadable Excel® template under the
            Import Data button. The import entry is recommended.
          </p>
          <ul>
            <li>
              If you import your portfolio data and desire portfolio privacy,
              the software will automatically insure Portfolio Privacy by
              securely standardizing all your input data.
            </li>
            <li>
              If you enter data on-screen, you must calculate your “Portfolio
              Value Factor” prior to proceeding. It is obtained by simply
              dividing your true starting portfolio value by 100; for example, a
              portfolio valued at $114,550 has a factor of 1145.5. Calculate
              this factor only once and from the starting month.
            </li>
            {portfolioEntry && portfolioEntry.dateRange && <li>
              The earliest permitted starting date is{" "}
              {moment(portfolioEntry.dateRange.startingDate)
                .endOf("month")
                .format("MMMM DD, YYYY")}
              .
            </li>}
            {portfolioEntry && portfolioEntry.dateRange && <li>
              The latest permitted ending date is{" "}
              {moment(portfolioEntry.dateRange.endDate)
                .endOf("month")
                .format("MMMM DD, YYYY")}
              .
            </li>}
            <li>
              All your reports’ portfolio values, transfers, and fees must be
              standardized by dividing each number by the single portfolio value
              factor.
            </li>
            <li>
              If management fees occur infrequently, there is a possibility that
              your analysis period either has insufficient fees or too many
              fees. In those cases, you should enter the equivalent fees,
              standardized in each month of your analysis period.
            </li>
          </ul>
        </div>
        <div style={{ margin: 30 }}>
          <ImportValues2 {...props} />
        </div>
      </div>
    </div>
  );
};

const Render = Portfolio;

function isComplete(props) {
  return true;
}

export { isComplete, Render };



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/ImportValuesSection.js